import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetConcernNamesResponse extends BackendResponse {
  items: { [key: number]: string };
}

export interface GetConcernNamesParameters extends NextApiParams {
  ids: number[];
}

export const getConcernNames = withNextApi<
  GetConcernNamesResponse,
  GetConcernNamesParameters
>("/auth/GetConcernNames", { method: "GET" });
